// IE 2026 10 08 / ODOO-5800 (Igor: «В виджетах страницы Сигналы нужно в форме-дропдаун по новой опции показать список объектов и возможность селекта по ним»):
// блок OBJECTS формы ячейки — объекты (номенклатура) за агрегированной ячейкой отчёта по сигналам (бэк cell_passport.objects, common_modules/cell_passport_objects.py)
// и выбор объекта чипсом «Object» стола (в память стола, без Save — как клик по строке page_goto_chip). Чистая логика без Vue / DOM — юнит tests/unit/cellObjects.test.mjs.
// Флаг fe.ux.cellPassportObjects (дефолт ВКЛ); выкл — параметр objects не уходит, блока нет.

export const OBJECTS_MAX = 200                     // строк в блоке; остальные — «+N more»
export const OBJECTS_CHIP_BINDING = 'object'        // чипс стола «Object» (relation DS::OBJECTS)
const SIGNALS_RE = /signal/i                        // id источника виджета, читающего данные сигналов (DS::Signals, MV::Signals-Data)

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))

// нужен ли запрос блока: флаг включён и среди используемых источников виджета есть источник сигналов (по id сегмента; бэк проверяет запись DS сам)
export function cellObjects_wanted({ source_segments, flagOn = true } = {}) {
    if (flagOn === false || !Array.isArray(source_segments)) return false
    return source_segments.some(s => isObj(s) && s.use !== false && !s.isSearchOnly && SIGNALS_RE.test(String(s.segment || '')))
}

// ответ бэка cell_passport.objects → модель блока: элементы по убыванию числа строк (затем по названию), не больше max, счётчики; null — блока нет (выкл / не сигналы / пусто)
export function cellObjects_model(raw, max = OBJECTS_MAX) {
    if (!isObj(raw) || raw.state !== 'ok' || !Array.isArray(raw.items)) return null
    const items = raw.items.filter(x => isObj(x) && x.id !== undefined && x.id !== null && x.id !== '')
        .map(x => ({ id: String(x.id), title: String(x.title || x.id), n: Number(x.n) || 0 }))
        .sort((a, b) => (b.n - a.n) || a.title.localeCompare(b.title) || a.id.localeCompare(b.id))
    if (!items.length) return null
    const lim = Math.max(1, Number(max) || OBJECTS_MAX)
    const shown = items.slice(0, lim)
    const total = Math.max(Number(raw.total) || 0, items.length)
    const rows = Number(raw.rows) || shown.reduce((s, x) => s + x.n, 0)
    return { items: shown, shown: shown.length, total, rows, more: Math.max(0, total - shown.length), partial: !!raw.partial, chip: String(raw.chip || OBJECTS_CHIP_BINDING), time: Number(raw.time) || 0 }
}

// сводка свёрнутого блока: «3 objects · 12 signals» (строки UI — английские, перевод словарём вызывающего)
export function cellObjects_summary(model, t = (s, p) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (p && k in p) ? String(p[k]) : m)) {
    if (!model) return ''
    const parts = [t(model.total === 1 ? '{n} object' : '{n} objects', { n: model.total })]
    if (model.rows) parts.push(t(model.rows === 1 ? '{n} signal' : '{n} signals', { n: model.rows }))
    return parts.join(' · ')
}

// конфиг чипса для pageGotoChip_run: чипс «Object» на ТЕКУЩЕЙ странице того же стола (переход никуда не ведёт, applySelector перечитывает участников); null — нет страницы
export function cellObjects_chipCfg(WIDGET, chip = OBJECTS_CHIP_BINDING) {
    const page = String((WIDGET && WIDGET.page) || '').trim()
    if (!page || !chip) return null
    return { page, chip_binding: chip, row_binding: chip, trigger: 'cell', workspace: '', column: '', condition: 'in' }
}
